import confetti from 'canvas-confetti';
import { CONFETTI_OPTIONS } from './config';

export const playConfettis = (endTimestamp: number) => {
  if (Date.now() >= endTimestamp) return;

  void confetti({ ...CONFETTI_OPTIONS, angle: 60 });
  void confetti({ ...CONFETTI_OPTIONS, angle: 120 });

  requestAnimationFrame(() => playConfettis(endTimestamp));
};
